import * as AesirApi from 'services/yggdrasil/api/aesirApi'

async function createContactToken () {
    return AesirApi.postToAesir('visitor-identification-token', {}, true)
}

const state = {
    hubspotChatIsAvailable: false,
    unreadConversationCount: 0,
    cookieBotReady: false,
    visitorIdentificationToken: null,
    hubspotChatIsOpen: false,
    cookieInfoVisible: true,
    hubSpotDisabledPopupVisible: true
}

const mutations = {
    HUBSPOT_CHAT_AVAILABLE (state, available) {
        state.hubspotChatIsAvailable = available
    },
    HUBSPOT_UNREAD_CONVERSATIONS_COUNT (state, count) {
        state.unreadConversationCount = count
    },
    HUBSPOT_COOKIEBOT_READY (state, done) {
        state.cookieBotReady = done
    },
    HUBSPOT_VISITOR_IDENTIFICATION_TOKEN_GENERATED (state, token) {
        state.visitorIdentificationToken = token
    },
    HUBSPOT_VISITOR_IDENTIFICATION_TOKEN_CLEARED (state) {
        state.visitorIdentificationToken = null
        delete window.hsConversationsSettings.identificationToken
        delete window.hsConversationsSettings.identificationEmail
        if (window.HubSpotConversations && window.HubSpotConversations.widget) {
            window.HubSpotConversations.widget.remove()
            window.HubSpotConversations.clear()
        }
    },
    HUBSPOT_CHAT_TOGGLE (state) {
        state.hubspotChatIsOpen = !state.hubspotChatIsOpen
    },
    CLOSE_COOKIE_INFO (state) {
        state.cookieInfoVisible = false
    },
    HUBSPOT_HIDE_DISABLED_POPUP (state) {
        state.hubSpotDisabledPopupVisible = false
    },
    HUBSPOT_SHOW_DISABLED_POPUP (state) {
        state.hubSpotDisabledPopupVisible = true
    }
}

const actions = {
    HubspotChatAvailable (store, available) {
        store.commit('HUBSPOT_CHAT_AVAILABLE', available)
    },
    UnreadConversationCountChanged (store, count) {
        store.commit('HUBSPOT_UNREAD_CONVERSATIONS_COUNT', count)
    },
    CookiebotReady (store, done) {
        store.commit('HUBSPOT_COOKIEBOT_READY', done)
    },
    async GenerateVisitorIdentificationToken (store, userId) {
        const { token } = await createContactToken()
        store.commit('HUBSPOT_VISITOR_IDENTIFICATION_TOKEN_GENERATED', token)
    },
    async ClearVisitorIdentificationToken (store) {
        store.commit('HUBSPOT_VISITOR_IDENTIFICATION_TOKEN_CLEARED', null)
    },
    toggleChat (store) {
        store.commit('HUBSPOT_CHAT_TOGGLE')
    },
    closeCookieInfo (store) {
        store.commit('CLOSE_COOKIE_INFO')
    },
    hideHubSpotDisabledPopup (store) {
        store.commit('HUBSPOT_HIDE_DISABLED_POPUP')
    },
    showHubSpotDisabledPopup (store) {
        store.commit('HUBSPOT_SHOW_DISABLED_POPUP')
    }
}

const getters = {
    hubspotChatIsAvailable: state => state.hubspotChatIsAvailable,
    unreadConversationCount: state => state.unreadConversationCount,
    cookieBotReady: state => state.cookieBotReady,
    visitorIdentificationToken: state => state.visitorIdentificationToken,
    hubspotChatIsOpen: state => state.hubspotChatIsOpen,
    cookieInfoVisible: state => state.cookieInfoVisible,
    hubSpotDisabledPopupVisible: state => state.hubSpotDisabledPopupVisible
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
